import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "services", label: "Services" },
  { id: "why-choose-us", label: "Why Us" },
  { id: "audit-checklist", label: "Audit Scope" },
  { id: "sap-digital", label: "SAP EHS" },
  { id: "about", label: "About" },
  { id: "contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`sticky top-0 z-50 bg-white border-b border-line transition-shadow ${
        scrolled ? "shadow-[0_1px_0_0_#0a0a0a]" : ""
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
          aria-label="Sabari Consultant home"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_sabari-safety/artifacts/aaa6fa1x_WhatsApp%20Image%202026-06-07%20at%209.05.22%20PM.jpeg"
            alt="Sabari Consultant"
            className="w-10 h-10 object-contain"
          />
          <span className="hidden sm:inline-block font-display text-base tracking-tight uppercase leading-none">
            Sabari<span className="text-accent-red">.</span>Consultant
            <span className="block font-mono text-[9px] tracking-[0.2em] text-ink-muted mt-1 normal-case">
              Consult · Train · Protect
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="px-4 py-2 text-sm font-medium hover:bg-black hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-consult"
            onClick={() => scrollTo("contact")}
            className="ml-3 btn-dark !py-2.5 !px-4 text-xs"
          >
            Book Consultation
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 -mr-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-line bg-white">
          <div className="flex flex-col">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-link-${l.id}`}
                onClick={() => scrollTo(l.id)}
                className="text-left px-6 py-4 border-b border-line text-sm font-medium hover:bg-bgalt"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta"
              onClick={() => scrollTo("contact")}
              className="text-left px-6 py-4 bg-black text-white text-sm font-semibold uppercase tracking-wider"
            >
              Book Consultation →
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
